import { usePublicCalculatorContext } from '~src/context/PublicCalculatorContext';
import { useSelectedProductTypesContext } from '~src/context/selectedProductTypeContext';
import { Offer } from '~src/model';

export const useHeaderSavingsEstimate = () => {
  const { residence, newOfferExpenses, offerProducts } = usePublicCalculatorContext();
  const { selectedProductTypes } = useSelectedProductTypesContext();

  const { heatPumpOutdoorUnit, heatPumpIndoorUnit, solarPanel, inverter, battery } = offerProducts ?? {};

  const offer = {
    ...(selectedProductTypes?.includes('heatPump') && {
      heatPumpOutdoorUnit,
      heatPumpIndoorUnit,
    }),
    ...(selectedProductTypes?.includes('solar') && { solarPanel, inverter, battery }),
  } as Offer;

  return {
    savingsAfterYears: 15,
    offer,
    residence,
    newOfferExpenses,
  };
};
